<template>
  <div :data-component-name="$options.name">
    <b-link
      v-bind="jel_getLienBinding(content.lien)"
      :ga-img-name="imageName"
      class="sans_underline row"
    >
      <b-col
        :class="content.cssColImage ? content.cssColImage + ' overflow-clip' : 'col-6 col-md-12'"
      >
        <img
          v-lazy="jel_getFichierSrc(content.image)"
          class="w-100 drop-shadow a-decouvrir"
          :data-tag="`${jel_getNomRouteCourante()} ${content.surTitre} - ${content.titre.replace(
            /&nbsp;/g,
            ' '
          )} - ${content.dataTag}`"
          :alt="content.image['@name']"
        />
      </b-col>
      <b-col
        :class="content.cssColTextes ? content.cssColTextes : 'col-6 col-md-12 ad-center-vert'"
      >
        <p class="mb-0 pt-md-1 ad-surtitre" v-html="content.surTitre"></p>
        <p class="graphik_medium ad-titre" :class="content.cssTitre">
          <span v-html="content.titre"></span>
        </p>
        <p :class="content.cssSousTitre" v-html="content.sousTitre"></p>
        <div class="h-50" v-html="content.texte"></div>
      </b-col>
    </b-link>
  </div>
</template>

<script>
export default {
  name: 'MediaImageImg70tit30',
  props: { content: { type: Object, required: true } },
  data() {
    return {};
  },
  computed: {
    classObject() {
      return {
        rounded: this.content.coinArrondi,
      };
    },
    imageName() {
      // TODO: M5
      // if (
      //   jel_getFichierSrc(this.content.imageFond) &&
      //   jel_getFichierSrc(this.content.imageFond).indexOf('jcr:') > 0
      // ) {
      //   return jel_getFichierSrc(this.content.imageFond).substring(
      //     parseInt(jel_getFichierSrc(this.content.imageFond).lastIndexOf('/') + 1),
      //     jel_getFichierSrc(this.content.imageFond).lastIndexOf('.')
      //   );
      // }
      // if (this.content.image && this.content.image.indexOf('jcr:') > 0) {
      //   return this.content.image.substring(
      //     parseInt(this.content.image.lastIndexOf('/') + 1),
      //     this.content.image.lastIndexOf('.')
      //   );
      // }
      return '';
    },
    styleObject() {
      return {
        'background-color':
          this.content.fondCouleur?.field === 'couleurEdit'
            ? this.content.fondCouleur.secBgThemeColor
            : null,
      };
    },
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.row {
  background-position: center;
  background-repeat: no-repeat;
}
.row.bgcover {
  background-size: cover;
}
.container-fluid {
  padding: 0;
}

.ad-center-vert {
  margin-bottom: auto;
  margin-top: auto;
}
.ad-surtitre {
  color: #000000;
  @include ms-respond(font-size, -1);
}
.ad-titre {
  color: #000000;
  @include ms-respond(font-size, 0);
}

@include media-breakpoint-down(md) {
  .ad-surtitre {
    @include ms-respond(font-size, 0);
  }
  .ad-titre {
    @include ms-respond(font-size, 1);
  }
}
.drop-shadow {
  -webkit-box-shadow: 2px 0px 15px 1px rgba(181, 181, 181, 0.4);
  -moz-box-shadow: 2px 0px 15px 1px rgba(181, 181, 181, 0.4);
  box-shadow: 2px 0px 15px 1px rgba(181, 181, 181, 0.4);
}

.a-decouvrir {
  /* La transition s'applique à la fois sur la largeur et la hauteur, avec une durée d'une seconde. */
  -webkit-transition: all 1s ease; /* Safari et Chrome */
  -moz-transition: all 1s ease; /* Firefox */
  -ms-transition: all 1s ease; /* Internet Explorer 9 */
  -o-transition: all 1s ease; /* Opera */
  transition: all 1s ease;
  transition: transform 1s;
}
.a-decouvrir:hover {
  /* L'image est grossie de 1.05% */
  -webkit-transform: scale(1.05); /* Safari et Chrome */
  -moz-transform: scale(1.05); /* Firefox */
  -ms-transform: scale(1.05); /* Internet Explorer 9 */
  -o-transform: scale(1.05); /* Opera */
  transform: scale(1.05);
}
.overflow-clip {
  /* L'image reste dans le cadre en hover*/
  overflow: clip;
  overflow-clip-margin: content-box;
}
</style>
